import RS from '~/api';
import { KEY_LIST_OF_SCENARIOS_STORAGE } from '~/constants';
import { getFromSessionStorage, saveToSessionStorage } from '~/helpers/storage';
import { saveWidgetHasChanges, widgetsHasChanges } from '~/utils/widgetsHasChanges';

/**
 * Проверяет, была ли уже инициализация сценариев
 * @returns true - если еще не было инициализации
 */
const dontInitialized = () => {
  return !getFromSessionStorage(KEY_LIST_OF_SCENARIOS_STORAGE, 'scenarios');
};
/**
 * Инициализация работы сценариев
 */
export const initScenarios = () => {

  const hasChanges = widgetsHasChanges();

  return (dontInitialized() || hasChanges)
    ? RS.scenarios.get().then((response) => {

      if (hasChanges) {
        saveWidgetHasChanges();
      }

      saveToSessionStorage(
          KEY_LIST_OF_SCENARIOS_STORAGE,
          'scenarios',
          response.payload.filter(scenario => scenario.name !== 'FortuneWheel')
        );
    })
    : Promise.resolve();
};
